export enum EumYang {
  EUM,
  YANG,
}
